/**
 * Generated by orval
 * Do not edit manually.
 * Veronics, Version=0.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CurrentAndActiveSemesterDTO,
  OrganizationAdminDTO,
  UpdateOrganizationDTO
} from './model';

import { customInstance } from '../custom-axios-instance';
import type { ErrorType } from '../custom-axios-instance';





export const adminOrganizationUpdateOrganization = (
    organizationId: number,
    updateOrganizationDTO: UpdateOrganizationDTO,
 ) => {
      
      
      return customInstance<OrganizationAdminDTO>(
      {url: `/api/organizations/${organizationId}/admin/AdminOrganization/update`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateOrganizationDTO
    },
      );
    }
  


export const getAdminOrganizationUpdateOrganizationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminOrganizationUpdateOrganization>>, TError,{organizationId: number;data: UpdateOrganizationDTO}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof adminOrganizationUpdateOrganization>>, TError,{organizationId: number;data: UpdateOrganizationDTO}, TContext> => {
    
const mutationKey = ['adminOrganizationUpdateOrganization'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminOrganizationUpdateOrganization>>, {organizationId: number;data: UpdateOrganizationDTO}> = (props) => {
          const {organizationId,data} = props ?? {};

          return  adminOrganizationUpdateOrganization(organizationId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminOrganizationUpdateOrganizationMutationResult = NonNullable<Awaited<ReturnType<typeof adminOrganizationUpdateOrganization>>>
    export type AdminOrganizationUpdateOrganizationMutationBody = UpdateOrganizationDTO
    export type AdminOrganizationUpdateOrganizationMutationError = ErrorType<unknown>

    export const useAdminOrganizationUpdateOrganization = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminOrganizationUpdateOrganization>>, TError,{organizationId: number;data: UpdateOrganizationDTO}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminOrganizationUpdateOrganization>>,
        TError,
        {organizationId: number;data: UpdateOrganizationDTO},
        TContext
      > => {

      const mutationOptions = getAdminOrganizationUpdateOrganizationMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const adminOrganizationGetOrganization = (
    organizationId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<OrganizationAdminDTO>(
      {url: `/api/organizations/${organizationId}/admin/AdminOrganization`, method: 'GET', signal
    },
      );
    }
  

export const getAdminOrganizationGetOrganizationQueryKey = (organizationId: number,) => {
    return [`/api/organizations/${organizationId}/admin/AdminOrganization`] as const;
    }

    
export const getAdminOrganizationGetOrganizationQueryOptions = <TData = Awaited<ReturnType<typeof adminOrganizationGetOrganization>>, TError = ErrorType<unknown>>(organizationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminOrganizationGetOrganization>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminOrganizationGetOrganizationQueryKey(organizationId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminOrganizationGetOrganization>>> = ({ signal }) => adminOrganizationGetOrganization(organizationId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(organizationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminOrganizationGetOrganization>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminOrganizationGetOrganizationQueryResult = NonNullable<Awaited<ReturnType<typeof adminOrganizationGetOrganization>>>
export type AdminOrganizationGetOrganizationQueryError = ErrorType<unknown>


export function useAdminOrganizationGetOrganization<TData = Awaited<ReturnType<typeof adminOrganizationGetOrganization>>, TError = ErrorType<unknown>>(
 organizationId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminOrganizationGetOrganization>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminOrganizationGetOrganization>>,
          TError,
          Awaited<ReturnType<typeof adminOrganizationGetOrganization>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminOrganizationGetOrganization<TData = Awaited<ReturnType<typeof adminOrganizationGetOrganization>>, TError = ErrorType<unknown>>(
 organizationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminOrganizationGetOrganization>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminOrganizationGetOrganization>>,
          TError,
          Awaited<ReturnType<typeof adminOrganizationGetOrganization>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminOrganizationGetOrganization<TData = Awaited<ReturnType<typeof adminOrganizationGetOrganization>>, TError = ErrorType<unknown>>(
 organizationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminOrganizationGetOrganization>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminOrganizationGetOrganization<TData = Awaited<ReturnType<typeof adminOrganizationGetOrganization>>, TError = ErrorType<unknown>>(
 organizationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminOrganizationGetOrganization>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminOrganizationGetOrganizationQueryOptions(organizationId,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const adminOrganizationGetCurrentAndActiveSemester = (
    organizationId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<CurrentAndActiveSemesterDTO>(
      {url: `/api/organizations/${organizationId}/admin/AdminOrganization/current-and-active-semester`, method: 'GET', signal
    },
      );
    }
  

export const getAdminOrganizationGetCurrentAndActiveSemesterQueryKey = (organizationId: number,) => {
    return [`/api/organizations/${organizationId}/admin/AdminOrganization/current-and-active-semester`] as const;
    }

    
export const getAdminOrganizationGetCurrentAndActiveSemesterQueryOptions = <TData = Awaited<ReturnType<typeof adminOrganizationGetCurrentAndActiveSemester>>, TError = ErrorType<unknown>>(organizationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminOrganizationGetCurrentAndActiveSemester>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminOrganizationGetCurrentAndActiveSemesterQueryKey(organizationId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminOrganizationGetCurrentAndActiveSemester>>> = ({ signal }) => adminOrganizationGetCurrentAndActiveSemester(organizationId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(organizationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminOrganizationGetCurrentAndActiveSemester>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminOrganizationGetCurrentAndActiveSemesterQueryResult = NonNullable<Awaited<ReturnType<typeof adminOrganizationGetCurrentAndActiveSemester>>>
export type AdminOrganizationGetCurrentAndActiveSemesterQueryError = ErrorType<unknown>


export function useAdminOrganizationGetCurrentAndActiveSemester<TData = Awaited<ReturnType<typeof adminOrganizationGetCurrentAndActiveSemester>>, TError = ErrorType<unknown>>(
 organizationId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminOrganizationGetCurrentAndActiveSemester>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminOrganizationGetCurrentAndActiveSemester>>,
          TError,
          Awaited<ReturnType<typeof adminOrganizationGetCurrentAndActiveSemester>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminOrganizationGetCurrentAndActiveSemester<TData = Awaited<ReturnType<typeof adminOrganizationGetCurrentAndActiveSemester>>, TError = ErrorType<unknown>>(
 organizationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminOrganizationGetCurrentAndActiveSemester>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminOrganizationGetCurrentAndActiveSemester>>,
          TError,
          Awaited<ReturnType<typeof adminOrganizationGetCurrentAndActiveSemester>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminOrganizationGetCurrentAndActiveSemester<TData = Awaited<ReturnType<typeof adminOrganizationGetCurrentAndActiveSemester>>, TError = ErrorType<unknown>>(
 organizationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminOrganizationGetCurrentAndActiveSemester>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminOrganizationGetCurrentAndActiveSemester<TData = Awaited<ReturnType<typeof adminOrganizationGetCurrentAndActiveSemester>>, TError = ErrorType<unknown>>(
 organizationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminOrganizationGetCurrentAndActiveSemester>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminOrganizationGetCurrentAndActiveSemesterQueryOptions(organizationId,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



